import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Event from '../pages/index';
import CreateEvent from '../pages/create';
import EventDetail from '../pages/detail';
import EditEvent from '../pages/edit';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import { RouteNameEnum } from '../../../enums/routeName';
import { PermissionEnum } from '../../../enums/permission';

const routes = [
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.eventViewList],
    },
    routeProperties: {
      path: RouteNameEnum.event.index,
      element: <Event />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.eventCreate],
      redirectUrl: RouteNameEnum.event.index,
    },
    routeProperties: {
      path: RouteNameEnum.event.create,
      element: <CreateEvent />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.eventViewList],
      redirectUrl: RouteNameEnum.event.index,
    },
    routeProperties: {
      path: RouteNameEnum.event.detail,
      element: <EventDetail />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.eventEdit],
      redirectUrl: RouteNameEnum.event.index,
    },
    routeProperties: {
      path: RouteNameEnum.event.edit,
      element: <EditEvent />,
    },
  },
];

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      {routes.map((route) => (
        <Route key={route.routeProperties.path} element={<PrivateOutlet {...route.privateProperties} />}>
          <Route key={`inner-${route.routeProperties.path}`} {...route.routeProperties} />
        </Route>
      ))}
    </Route>
  </Routes>
);

export default BaseRoutes;
